/** @jsx jsx */
import { css, jsx, withTheme } from "@fckdtl/themotion/react";

const Grid = ({ theme, children, as: Tag = "div", ...props }) => (
  <Tag {...props}>{children}</Tag>
);

export default withTheme(Grid);
